export default {"src":"https://s.sylndr.com/c-00317d6/_next/static/media/wideAngleIcon.c7a8fd89.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};